import { BadgeDecorator } from "@molecules/BadgeDecorator";
import DOMPurify from "dompurify";
import { twMerge } from "tailwind-merge";

type TInitialIntroProps = {
  badgeText: string | null;
  strongText: string;
  description: string | null;
  descriptionClass?: string | null;
};

export const InitialIntro = ({
  badgeText,
  strongText,
  description,
  descriptionClass,
}: TInitialIntroProps) => {
  const InitialIntroElement = document.createElement("div");
  InitialIntroElement.className = "flex flex-col gap-6";

  if (badgeText) InitialIntroElement.appendChild(BadgeDecorator(badgeText));

  const fullDescriptionClass = twMerge(
    "text-xl font-normal text-center text-gray-400",
    descriptionClass ?? "",
  );

  const descriptionElement = description
    ? /* html */ `
            <h4 class="${fullDescriptionClass}">${description}</h4>  
        `
    : "";

  InitialIntroElement.innerHTML += DOMPurify.sanitize(/* html */ `
        <div class="flex flex-col gap-2">
            <h1 class="text-3xl font-medium text-blue-800 text-center md:text-4xl">
                ${strongText}
            </h1>
        
            ${descriptionElement}
        </div>
    `);

  return InitialIntroElement;
};
